import {
  ROUTE_EDIT_EVENT,
  ROUTE_EVENT_CREATE,
  ROUTE_EVENT_DATE,
  ROUTE_EVENT_DATE_FORM,
  ROUTE_EVENTS,
} from '@/router/routes/routeNames'
import EventEditView from '@/components/events/EventEditView.vue'
import EventCreateView from '@/components/events/EventCreateView.vue'
import EventDateFormView from '@/components/product/product_components/component_events/event_views/EventDateFormView.vue'
import EventDatesView from '@/components/product/product_components/component_events/event_views/EventDatesView.vue'
import EventDateInfoView from '@/components/product/product_components/component_events/event_views/EventDateInfoView.vue'

const EventsView = () => import('@/components/events/EventsView.vue')

const eventRoutes = [
  {
    name: ROUTE_EVENTS,
    path: '/events',
    component: EventsView,
    meta: {
      resource: 'Events',
    },
  },
  {
    name: ROUTE_EVENT_CREATE,
    path: '/events/create',
    props: true,
    component: EventCreateView,
    meta: { resource: 'Events', requiresPortal: true },
  },
  {
    path: '/events/:productId',
    component: EventEditView,
    meta: {
      resource: 'Events',
      requiresPortal: true,
      showGlobalHeader: false,
    },
    children: [
      {
        name: ROUTE_EDIT_EVENT,
        path: '',
        component: EventDatesView,
        meta: {
          resource: 'Events',
        },
      },
      {
        name: ROUTE_EVENT_DATE,
        path: 'dates/:courseId',
        component: EventDateInfoView,
        meta: {
          resource: 'Events',
        },
      },
      {
        name: ROUTE_EVENT_DATE_FORM,
        path: 'dates/:courseId/form',
        component: EventDateFormView,
        meta: {
          resource: 'Events',
        },
      },
    ],
  },
]

export default eventRoutes
